import { Injectable } from '@angular/core';
import { AbilityFactory, AppAbility } from '@configs/ability.config';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AbilityGeneratorService {
  private abilitySubject = new BehaviorSubject<AppAbility | null>(null);

  constructor(private abilityFactory: AbilityFactory) {}

  get ability$(): Observable<AppAbility> {
    return this.abilitySubject.asObservable();
  }

  get ability(): AppAbility {
    return this.abilitySubject.value;
  }

  updateAbility(scopes: string[]): void {
    const newAbility = this.abilityFactory.createAbility(scopes);
    this.abilitySubject.next(newAbility);
  }
}
